/**
 * Review-card-count React Query key.
 *
 * NOTE (legacy): this file previously also exported a `ReviewInsights`
 * component, but nothing rendered it — DictionaryHero (the live iOS-parity
 * entry point) and the feed only ever consumed this query-key constant. The
 * dead component (with pre-parity copy/logic that diverged from iOS) was
 * removed. The constant lives here for now because un-owned modules
 * (feed/features/*, pages/VideoPage, components/Dictionary/DictionaryHero) and
 * the review hooks import it from this path; the proper home is
 * src/query_keys.tsx (see userCheck), which requires touching those importers.
 */
export const REVIEW_CARD_COUNT_QUERY_KEY = "reviewCardsStats";
